module.exports = __webpack_public_path__ + "img/dd43105.jpg";